<app-table [table]="generalInfoTable"></app-table>
